/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Tab3Inputs */

const zh_landing_admin_tab3 = /** @type {(inputs: Landing_Admin_Tab3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内置 AI 辅导`)
};

const en_landing_admin_tab3 = /** @type {(inputs: Landing_Admin_Tab3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-in AI tutor`)
};

const es_landing_admin_tab3 = /** @type {(inputs: Landing_Admin_Tab3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor IA integrado`)
};

/**
* | output |
* | --- |
* | "Built-in AI tutor" |
*
* @param {Landing_Admin_Tab3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_tab3 = /** @type {((inputs?: Landing_Admin_Tab3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Tab3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_tab3(inputs)
	if (locale === "en") return en_landing_admin_tab3(inputs)
	return es_landing_admin_tab3(inputs)
});